export default "__VITE_ASSET__D8osGG2V__"